interface SidebarTextFieldProps {
  label: string;
  value: string;
}

/**
 * Read-only free text, e.g. a reason someone typed. Styled like the sidebar
 * fields in OrderDetailSidebar, but it wraps instead of truncating and keeps
 * full opacity: the text is the content, and a one-line excerpt is useless.
 */
export function SidebarTextField({ label, value }: SidebarTextFieldProps) {
  return (
    <div className="tw:flex tw:flex-col tw:gap-3">
      <p className="tw:text-sm tw:font-medium">{label}</p>
      <p className="tw:border-input tw:dark:bg-input/30 tw:w-full tw:rounded-md tw:border tw:px-3 tw:py-2 tw:shadow-xs tw:text-sm tw:text-foreground tw:whitespace-pre-wrap tw:break-words">
        {value}
      </p>
    </div>
  );
}
